import { defineMessages } from 'react-intl';

export const FLAME_ISOLATION_NAV_MESSAGES = defineMessages({
  goBack: {
    id: 'mdgoWaXS0EbXGIlz',
    defaultMessage: 'Isolation: back',
    description:
      'Accessible label for the isolation navigation button that moves one level toward the original root of the flame chart or flame graph.',
  },
  goForward: {
    id: 'ZddDsKUiSczT7I3C',
    defaultMessage: 'Isolation: forward',
    description:
      'Accessible label for the isolation navigation button that re-advances one level along the previously taken isolation path.',
  },
});
